// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-action.verify-phone .participant-phone {
  display: inline-block;
}

.verify-phone .instructions {
  width: 280px;
    line-height: 1.5;
    margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/VerifyPhone.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;IACV,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".login-action.verify-phone .participant-phone {\n  display: inline-block;\n}\n\n.verify-phone .instructions {\n  width: 280px;\n    line-height: 1.5;\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
